"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get isCloud () {
        return isCloud;
    },
    get isEE () {
        return isEE;
    },
    get isOnPrem () {
        return isOnPrem;
    }
});
const isEE = false;
const isOnPrem = false;
const isCloud = false;
